/**
 * List of available payment methods.
 * Each payment method is represented as an object with a `value` and a `label`.
 */
export const paymentMethodsList = [
    { value: "cash", label: "Efectivo" },
    { value: "credit_debit_card", label: "Tarjetas de crédito/débito" },
    { value: "bank_transfer", label: "Transferencias bancarias" },
    { value: "electronic_payments", label: "Pagos electrónicos/móviles" }
];

/**
 * Retrieves the label of a payment method given its value.
 * @param {string} value - The value of the payment method to look up.
 * @returns {string|null} The label of the payment method if found; otherwise, null.
 */
export const getPaymentMethodLabelByValue = (value) => {
    const normalized = String(value || "").toLowerCase();
    if (normalized === "unknown" || normalized === "unknow") return "Desconocido";
    const method = paymentMethodsList.find(paymentMethod => paymentMethod.value === value);
    return method ? method.label : null;
};
